import React from 'react';

function Messages() {
  return (
    <div className='text-white'>Messages</div>
  )
}

export default Messages;